import React, { FC, useEffect, useMemo, useState } from 'react'
import { Button } from '@ucheba/ui/components/Button/desktop'
import GraduationCapIcon from '@ucheba/ui/icons/icon__graduation-cap.svg'
import GraduationCapCheckIcon from '@ucheba/ui/icons/icon__graduation-cap-check.svg'
import { useInView } from 'react-intersection-observer'
import { useSelector } from 'react-redux'
import { learningRequestSelector } from '@ucheba/store/institutions/learningRequest'
import { plannerPlanSelectors } from '@ucheba/store/planner/plan'
import { ELoading } from '@ucheba/store/utils/response/types'
import { IWantToStudyProps } from '../types'
import ButtonHint from '../components/ButtonHint/desktop'
import { RelativeContainer } from '../styles'
import { useWantToStudyCore } from '../bll/useWantToStudyCore'
import AlternativeButton from '../components/AlternativeButton'

const WantToStudy: FC<IWantToStudyProps> = (props) => {
  const {
    block = false,
    alternativeButtonBlock = false,
    isShortText = false,
    isInPlanOfAdmission,
    width,
    view,
    color = 'blue',
    programId,
    institutionId,
    institutionType,
    programType,
    handleWantToStudy,
    size = 'medium',
    type = 'institution',
    alternativeButtonView = 'default',
    isShowingHint = true,
    isAuth = false,
    buttonText,
  } = props

  const learningRequestLoading = useSelector(learningRequestSelector.loading)
  const plannerPlanLoading = useSelector(plannerPlanSelectors.loading)

  const isLoading =
    learningRequestLoading === ELoading.pending || plannerPlanLoading === ELoading.pending

  const { isCollegeOrUniversity, isTypeOfApplicationProgram } = useWantToStudyCore({
    institutionType,
    programType,
  })

  const { ref, inView } = useInView({
    threshold: 1,
  })

  const [showHint, setShowHint] = useState(false)

  useEffect(() => {
    if (inView && !showHint) setShowHint(true)
  }, [inView, showHint])

  const Icon = isInPlanOfAdmission ? <GraduationCapCheckIcon /> : <GraduationCapIcon />

  const hintTextForSpeciality = useMemo(() => {
    return 'Нажав на «Добавить в план», вы добавите эту специальность в '
  }, [])

  const hintTextForInstitution = useMemo(() => {
    return 'Нажав на «Хочу поступить», вы добавите это учебное заведение в '
  }, [])

  // Кнопка "Хочу поступить"
  // Для добавления УЗ или программы в план поступления
  if (
    (programType && isTypeOfApplicationProgram) ||
    (institutionType && isCollegeOrUniversity) ||
    type === 'specialities'
  )
    return (
      <RelativeContainer>
        <Button
          ref={ref}
          id='step-1'
          view={view || isInPlanOfAdmission ? 'outline' : 'default'}
          onClick={handleWantToStudy}
          StartIcon={Icon}
          color={color}
          block={block}
          size={size}
          width={width}
          progress={isLoading}
        >
          {/* eslint-disable-next-line no-nested-ternary */}
          {isInPlanOfAdmission
            ? isShortText
              ? 'В плане'
              : 'В плане поступления'
            : buttonText}
        </Button>

        {type === 'specialities'
          ? showHint &&
            isShowingHint &&
            !isAuth && <ButtonHint hintText={hintTextForSpeciality} />
          : showHint && isShowingHint && <ButtonHint hintText={hintTextForInstitution} />}
      </RelativeContainer>
    )

  // кнопка "Хочу здесь учиться"
  return (
    <AlternativeButton
      referId={programId && type === 'program' ? programId : institutionId}
      size={size}
      type={type}
      block={alternativeButtonBlock}
      alternativeButtonView={alternativeButtonView}
    />
  )
}

export default WantToStudy
